import type {
  FeedProductInterface,
  OfferPriceType,
  SearchSupplierStockType,
  StockItemType,
} from '@/types'

const routeKey = (route: string[] | undefined) => (route ?? []).join('>')

type OfferStock = Pick<StockItemType, 'route' | 'storeShortModel'>

const findStorePrice = (prices: OfferPriceType[], stock: OfferStock) => {
  const stockRoute = routeKey(stock.route)
  const storeCode = stock.storeShortModel.code
  const sameRoute = prices.filter(
    (price) => routeKey(price.route) === stockRoute
  )

  return (
    sameRoute.find((price) => price.storeCode === storeCode) ??
    sameRoute.find((price) => price.storeCode === undefined) ??
    prices.find(
      (price) => price.storeCode === undefined || price.storeCode === storeCode
    )
  )
}

export const getOfferPrice = (
  supplier: Pick<SearchSupplierStockType, 'prices'> | undefined,
  stock: OfferStock | undefined
): OfferPriceType | undefined => {
  if (!supplier) return undefined
  if (!stock) return supplier.prices[0]
  return findStorePrice(supplier.prices, stock)
}

export const getRowOfferPrice = ({
  suppliersStock,
}: Pick<FeedProductInterface, 'suppliersStock'>) =>
  getOfferPrice(suppliersStock[0], suppliersStock[0]?.stock[0])
